module.exports = __webpack_public_path__ + "img/cancellations.ee27015b.svg";